import { CONTENT_WIDTH_CENTERED_2_COLUMN } from '@sleepstation/metrics-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import BreakoutModule from '../BreakoutModule'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const BreakoutModuleNarrow = (props) => (
  <BreakoutModule {...props} maxWidths={CONTENT_WIDTH_CENTERED_2_COLUMN} />
)

BreakoutModuleNarrow.propTypes = {
  hasBottomBorder: PropTypes.bool,
  hasGradient: PropTypes.bool,
}

BreakoutModuleNarrow.defaultProps = {
  hasBottomBorder: true,
  hasGradient: true,
}

export default BreakoutModuleNarrow
